// extracted by mini-css-extract-plugin
export default {"menuBlock":"lH-z","title":"mH-z","nav":"nH-z","flexCell":"oH-z","facetLink":"pH-z"};